import React from "react";

import { Box, Grid, Stack, Typography } from "@mui/material";

import { LiveDrawCards } from "../../cards";

import powerballImage from "../../../../../static/Images/powerball.png";
import revolverImage from "../../../../../static/Images/revolver.png";
import mineImage from "../../../../../static/Images/mine.png";

import "../liveGames/liveGames.css";

import { colors } from "../../../../../theme";

// Static placeholder data for live draws
const liveGames = [
  {
    title: "Powerball",
    type: "Lottery",
    roundNumber: "212394",
    numbers: [7, 11, 23, 32, 41, 17],
    countdown: "12 : 24 : 36",
    image: powerballImage,
    accentColor: colors.ribbon.deltaNegative,
  },
  {
    title: "Revolver",
    type: "Spinner",
    roundNumber: "87921",
    countdown: "00 : 04 : 21",
    image: revolverImage,
    accentColor: colors.charts.amber,
  },
  {
    title: "Mine",
    type: "Original",
    roundNumber: "141220",
    countdown: "02 : 15 : 08",
    image: mineImage,
    accentColor: colors.blue[500],
  },
];

const LiveGames = () => {
  return (
    <Box
      component="section"
      className="home-live-draws"
      sx={{
        py: { xs: "40px", md: "50px", lg: "60px" },
        px: { xs: "20px", md: "5vw" },
      }}
    >
      {/* Header Section */}
      <Stack
        className="live-draws-header"
        direction={{ xs: "column", sm: "row" }}
        alignItems={{ xs: "flex-start", sm: "flex-end" }}
        justifyContent="space-between"
        sx={{
          mb: { xs: "28px", md: "34px", lg: "42px" },
        }}
      >
        <Box>
          <Typography
            component="p"
            className="live-draws-eyebrow"
            sx={{
              color: "primary.main",
              fontSize: "11px",
              fontWeight: 800,
              letterSpacing: "0.16em",
              textTransform: "uppercase",
              mb: "10px",
              m: 0,
            }}
          >
            LIVE DRAWS
          </Typography>

          <Typography
            component="h2"
            className="live-draws-title"
            sx={{
              color: "custom.colors.home.navyDark",
              fontSize: { xs: "42px", md: "52px", lg: "64px" },
              fontWeight: 800,
              lineHeight: { xs: 1.08, lg: 1.05 },
              letterSpacing: "-0.035em",
              m: 0,
            }}
          >
            Live & Transparent
          </Typography>
        </Box>

        <Typography
          component="a"
          href="/all-lottery"
          className="live-draws-link"
          sx={{
            color: "custom.colors.home.navyDark",
            fontSize: { xs: "12px", md: "13px" },
            fontWeight: 700,
            textDecoration: "none",
            whiteSpace: "nowrap",
            transition: "color 0.3s ease, transform 0.3s ease",
            position: "relative",
            "&:hover": {
              color: "primary.main",
              transform: "translateX(3px)",
              "&::after": {
                transform: "scaleX(1)",
                transformOrigin: "left",
              },
            },
            "&::after": {
              content: '""',
              position: "absolute",
              left: 0,
              bottom: "-6px",
              width: "100%",
              height: "1px",
              bgcolor: "currentColor",
              transform: "scaleX(0)",
              transformOrigin: "right",
              transition: "transform 0.3s ease",
            },
          }}
        >
          View All Draws
        </Typography>
      </Stack>

      {/* Live Draw Cards Grid */}
      <Grid
        container
        spacing={3}
        className="live-draws-grid"
      >
        {liveGames.map((game) => (
          <Grid
            item
            xs={12}
            md={4}
            key={game.title}
            className="live-draw-card-wrapper"
          >
            <LiveDrawCards
              image={game.image}
              title={game.title}
              type={game.type}
              roundNumber={game.roundNumber}
              numbers={game.numbers}
              countdown={game.countdown}
              accentColor={game.accentColor}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default LiveGames;